/* HUSHLY KIDS : fusion automatique des oreillers au panier (24/09/2026, Antonin).
   Apres chaque ajout d'oreiller (fiche, barre collante, accueil), tous les oreillers du panier
   sont reconstruits en packs : pack de 4 d'abord, puis le reste, dans l'ordre d'ajout.
   - Chaque oreiller garde sa taille : variante = oreiller 1, notes « Pillow N age » = les suivants.
   - Les taies offertes deja choisies (motif + taille) sont reprises dans l'ordre ; une taie
     nouvellement debloquee prend le motif par defaut et la taille de l'oreiller qui la debloque
     (oreiller 3 pour la 1re taie, oreiller 4 pour la 2e).
   - Housses payantes sans note : regroupees par taille + motif en lots de 3 puis le reste (24/09).
   - Les autres produits ne sont jamais touches.
   - Securite : on n'agit que si toutes les notes des lignes sont connues et toutes les variantes
     cibles disponibles ; on ajoute avant de retirer ; on relit le panier ; si le resultat n'est pas
     exactement celui attendu, on remet le panier d'origine.
   Config posee par snippets/hushly-cart-merge.liquid : window.HK_MERGE. */
(function () {
  var C = window.HK_MERGE;
  if (!C || !C.variants) return;
  var RUNNING = false;
  var RE_KNOWN = /^(Pillow [2-4] age|Free pillowcase [1-4] (age|print))$/;

  function packOf(v) { return parseInt(String(v).split(' ')[0], 10) || 0; }
  /* 12/10/2026 (Antonin) : taies offertes par pack. 1 oreiller = 0 taie, 2 oreillers = 1 taie, 3 oreillers = 2 taies (pack 4 masque du site depuis le 12/10 : 2). Avant (27/09) : une taie par oreiller. Seul endroit du fichier ou ce nombre est fixe. */
  var FREE_CASES_BY_PACK = { 1: 0, 2: 1, 3: 2, 4: 2 };
  function casesFor(n) { return FREE_CASES_BY_PACK[n] || 0; }
  function vid(pack, age) {
    for (var i = 0; i < C.variants.length; i++) {
      var v = C.variants[i];
      if (v.pack === pack && v.age === age && v.available) return v.id;
    }
    return null;
  }
  function vinfo(id) {
    for (var i = 0; i < C.variants.length; i++) if (C.variants[i].id === id) return C.variants[i];
    return null;
  }
  function clean(props) {
    var out = {};
    Object.keys(props || {}).forEach(function (k) {
      var v = props[k];
      if (v === null || v === undefined || v === '') return;
      out[k] = String(v);
    });
    return out;
  }
  function canon(id, props) {
    var p = clean(props);
    return id + '|' + Object.keys(p).sort().map(function (k) { return k + '=' + p[k]; }).join(';');
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'refus'); return d; });
    });
  }

  /* Lignes oreiller du panier, dans l'ordre d'ajout (Shopify met la plus recente en tete). */
  function pillowLines(cart) {
    return cart.items.filter(function (it) { return it.handle === C.handle; }).slice().reverse();
  }
  /* 24/09 : housses payantes (sans note) : regroupees par taille + motif en lots de 3, puis le reste. */
  var K = C.cases || null;
  function caseLines(cart) {
    if (!K) return [];
    return cart.items.filter(function (it) {
      return it.handle === K.handle && !Object.keys(clean(it.properties)).length;
    }).slice().reverse();
  }
  function managed(cart) { return pillowLines(cart).concat(caseLines(cart)); }
  function cinfo(id) {
    for (var i = 0; i < K.variants.length; i++) if (K.variants[i].id === id) return K.variants[i];
    return null;
  }
  function cid(age, print, pack) {
    for (var i = 0; i < K.variants.length; i++) {
      var v = K.variants[i];
      if (v.age === age && v.print === print && v.pack === pack && v.available) return v.id;
    }
    return null;
  }
  function casePlan(cart) {
    var lines = caseLines(cart), groups = [], index = {};
    for (var i = 0; i < lines.length; i++) {
      var inf = cinfo(lines[i].variant_id);
      if (!inf) return null;
      var g = inf.age + '|' + inf.print;
      if (!(g in index)) { index[g] = groups.length; groups.push({ age: inf.age, print: inf.print, n: 0 }); }
      groups[index[g]].n += inf.pack * lines[i].quantity;
    }
    var out = [];
    for (var j = 0; j < groups.length; j++) {
      var left = groups[j].n;
      while (left > 0) {
        var s = Math.min(K.top, left), id = cid(groups[j].age, groups[j].print, s);
        if (!id) return null;
        out.push({ id: id, properties: {} });
        left -= s;
      }
    }
    return out;
  }

  /* Plan cible, ou null si on ne doit pas toucher au panier. */
  function plan(cart) {
    var lines = pillowLines(cart);
    if (!lines.length) return null;
    var ages = [], cases = [];
    for (var li = 0; li < lines.length; li++) {
      var it = lines[li], info = vinfo(it.variant_id);
      if (!info) return null;
      var props = clean(it.properties);
      var keys = Object.keys(props);
      for (var k = 0; k < keys.length; k++) if (!RE_KNOWN.test(keys[k])) return null; /* note inconnue : on ne touche a rien */
      for (var q = 0; q < it.quantity; q++) {
        ages.push(info.age);
        for (var n = 2; n <= info.pack; n++) ages.push(props['Pillow ' + n + ' age'] || info.age);
        for (var c = 1; c <= casesFor(info.pack); c++) {
          var a = props['Free pillowcase ' + c + ' age'], p = props['Free pillowcase ' + c + ' print'];
          cases.push(a && p ? { age: a, print: p } : null);
        }
      }
    }
    for (var x = 0; x < ages.length; x++) if (C.ages.indexOf(ages[x]) < 0) return null;
    /* decoupe : packs de 4, puis le reste */
    var packs = [], i = 0;
    while (i < ages.length) { var s = Math.min(C.top, ages.length - i); packs.push(ages.slice(i, i + s)); i += s; }
    var target = [], pool = cases.slice();
    for (var pi = 0; pi < packs.length; pi++) {
      var pk = packs[pi], id = vid(pk.length, pk[0]);
      if (!id) return null; /* variante indisponible : on ne touche a rien */
      var tp = {};
      for (var j = 2; j <= pk.length; j++) tp['Pillow ' + j + ' age'] = pk[j - 1];
      for (var cc = 1; cc <= casesFor(pk.length); cc++) {
        var got = pool.length ? pool.shift() : null;
        var dflt = { age: (casesFor(pk.length) === 1 && pk.length >= 2 ? pk[1] : pk[cc - 1]) || pk[0], print: C.print }; /* 27/09 : housse N = taille de l'oreiller N ; 12/10 : taie unique du pack 2 = oreiller 2 */
        var cs = got || dflt;
        if (C.hidden.indexOf(cs.print) >= 0) cs = { age: cs.age, print: C.print }; /* motif retire de la vente */
        tp['Free pillowcase ' + cc + ' age'] = cs.age;
        tp['Free pillowcase ' + cc + ' print'] = cs.print;
      }
      target.push({ id: id, properties: tp });
    }
    return { target: target, lines: lines };
  }

  function multiset(list) {
    var m = {};
    list.forEach(function (e) { var k = canon(e.id, e.properties); m[k] = (m[k] || 0) + (e.quantity || 1); });
    return m;
  }
  function currentSet(cart) {
    return multiset(managed(cart).map(function (it) { return { id: it.variant_id, properties: it.properties, quantity: it.quantity }; }));
  }
  function asIs(lines) {
    return lines.map(function (it) { return { id: it.variant_id, properties: clean(it.properties), quantity: it.quantity }; });
  }
  function fullPlan(cart) {
    var p = plan(cart), c = casePlan(cart);
    var pillows = p ? p.target : asIs(pillowLines(cart));
    var cases = c ? c : asIs(caseLines(cart));
    return pillows.concat(cases);
  }
  function same(a, b) {
    var ka = Object.keys(a), kb = Object.keys(b);
    if (ka.length !== kb.length) return false;
    for (var i = 0; i < ka.length; i++) if (a[ka[i]] !== b[ka[i]]) return false;
    return true;
  }

  /* Amene les lignes oreiller du panier exactement a la liste voulue (ajouts d'abord). */
  function apply(wanted) {
    var want = multiset(wanted), byKey = {};
    wanted.forEach(function (e) { byKey[canon(e.id, e.properties)] = e; });
    return getCart().then(function (cart) {
      var have = currentSet(cart), adds = [];
      Object.keys(want).forEach(function (k) {
        var miss = want[k] - (have[k] || 0);
        if (miss > 0) adds.push({ id: byKey[k].id, quantity: miss, properties: clean(byKey[k].properties) });
      });
      return (adds.length ? post('/cart/add.js', { items: adds }) : Promise.resolve()).then(getCart);
    }).then(function (cart) {
      var left = {}, updates = {}, n = 0;
      Object.keys(want).forEach(function (k) { left[k] = want[k]; });
      managed(cart).forEach(function (it) {
        var k = canon(it.variant_id, it.properties), keep = Math.min(it.quantity, left[k] || 0);
        left[k] = (left[k] || 0) - keep;
        if (keep !== it.quantity) { updates[it.key] = keep; n++; }
      });
      return n ? post('/cart/update.js', { updates: updates }) : null;
    }).then(getCart);
  }

  function render() {
    /* 25/09 : quand hushly-cart.js regroupe les housses apres une action du panier, il redessine
       lui-meme tiroir ET page /cart ; renderContents ouvrirait le tiroir par-dessus /cart. */
    if (window.__hkMergeQuiet) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    var url = window.location.pathname + '?sections=cart-drawer,cart-icon-bubble';
    return fetch(url, { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (sections) {
      try { drawer.classList.remove('is-empty'); drawer.renderContents({ id: null, sections: sections }); } catch (e) { console.warn('[hk-merge] rendu', e); }
    });
  }

  function busy(on) {
    var d = document.querySelector('cart-drawer');
    if (d) d.classList.toggle('hk-merging', !!on);
  }

  function normalize() {
    if (RUNNING) return Promise.resolve();
    RUNNING = true; busy(true);
    var original = null;
    return getCart().then(function (cart) {
      original = asIs(managed(cart));
      var target = fullPlan(cart);
      if (same(multiset(target), currentSet(cart))) return false; /* deja juste */
      return apply(target).then(function (after) {
        if (same(currentSet(after), multiset(target))) return true;
        throw new Error('resultat inattendu');
      });
    }).catch(function (err) {
      console.warn('[hk-merge] retour au panier d origine :', err);
      if (!original) return false;
      return apply(original).then(function () { return true; }, function () { return true; });
    }).then(function (changed) {
      return changed ? render() : null;
    }).then(function () { RUNNING = false; busy(false); }, function () { RUNNING = false; busy(false); });
  }

  window.hkNormalizeCart = normalize;

  /* 1. formulaire produit Dawn (fiche + barre collante qui clique sur le vrai bouton) */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (d) {
      if (d && d.source === 'product-form') setTimeout(normalize, 50);
    });
  }
  /* 2. bloc d'achat de l'accueil (hushly-buybox.js) */
  document.addEventListener('hushly:cart:added', function () { setTimeout(normalize, 350); });
})();
